var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifDismiss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3677 17.6153C18.5745 17.822 18.5745 18.1572 18.3677 18.364C18.161 18.5707 17.8258 18.5707 17.619 18.364L5.63978 6.38474C5.43304 6.17799 5.43304 5.84278 5.63978 5.63604C5.84653 5.42929 6.18174 5.42929 6.38849 5.63604L18.3677 17.6153Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6115 5.63604C17.8183 5.42929 18.1535 5.42929 18.3602 5.63604C18.567 5.84279 18.567 6.17799 18.3602 6.38474L6.381 18.364C6.17425 18.5707 5.83904 18.5707 5.6323 18.364C5.42555 18.1572 5.42555 17.822 5.63229 17.6153L17.6115 5.63604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3677 17.6153C18.5745 17.822 18.5745 18.1572 18.3677 18.364C18.161 18.5707 17.8258 18.5707 17.619 18.364L5.63978 6.38474C5.43304 6.17799 5.43304 5.84278 5.63978 5.63604C5.84653 5.42929 6.18174 5.42929 6.38849 5.63604L18.3677 17.6153Z",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6115 5.63604C17.8183 5.42929 18.1535 5.42929 18.3602 5.63604C18.567 5.84279 18.567 6.17799 18.3602 6.38474L6.381 18.364C6.17425 18.5707 5.83904 18.5707 5.6323 18.364C5.42555 18.1572 5.42555 17.822 5.63229 17.6153L17.6115 5.63604Z",
    stroke: "black",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifDismiss);
export default __webpack_public_path__ + "static/media/notif-dismiss.18268b9f7c70be366f78a279b1be5a3f.svg";
export { ForwardRef as ReactComponent };